import { v4 } from "uuid";

import { ILoggedUserDto } from "modules/user/application/types/ILoggedUserDto";
import { LoggedUserStatus } from "modules/user/application/types/LoggedUserStatus";

export const createUser = (user?: Partial<ILoggedUserDto>): ILoggedUserDto => {
  return {
    id: v4(),
    name: "Dragon Damian",
    email: "dragon.dc@gmail.com",
    phone: "666 666 666 ",
    loginDate: "12-05-2021",
    status: LoggedUserStatus.Active,
    token: "123123123",
    forceToChangePassword: 0,
    forceToCheckAgreementTerms: 0,
    ssoLogin: "",
    ssoConnection: 0,
    hasLocalAccount: 1,
    ...user,
  };
};
